<template>
  <div class="cooperative-school">
    <el-form size="mini" :inline="true">
      <el-form-item label="学校名称">
        <el-input placeholder="请输入学校名称" v-model="ruleForm.educational_institution_name" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="平台账号">
        <el-input placeholder="请输入平台账号" v-model="ruleForm.username" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="二级域名">
        <el-input placeholder="请输入二级域名" v-model="ruleForm.domain" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>

      <el-form-item label="客户标签">
        <el-select v-model="ruleForm.tagIds" multiple placeholder="请选择">
          <el-option v-for="item in schoolTagList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="科目">
        <el-select v-model="ruleForm.subjectIds" multiple filterable>
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="科目是否包含已到期">
        <el-select v-model="ruleForm.is_contain_timeout_subject">
          <el-option label="全部" value=""></el-option>
          <el-option label="包含" value="1"></el-option>
          <el-option label="不包含" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="到期时间">
        <el-date-picker v-model="ruleForm.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" placement="bottom-start"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary">查询</el-button>
      </el-form-item>

      <br />
      <el-button size="mini" @click="addSchool" type="primary" style="float:left" icon="el-icon-plus">新增合作校区</el-button>
      <el-button size="mini" style="float: left;margin-right:20px" type="primary" @click="allAdd">批量添加课程体系</el-button>
    </el-form>
    <div class="table-style">
      <el-table size="mini" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column width="50" align="center" prop="id" label="序号" fixed="left">
          <template slot-scope="scope">{{
            scope.$index + 1 + 20 * (page_no - 1)
          }}</template>
        </el-table-column>

        <el-table-column width="200" align="left" label="校区名称" fixed="left">
          <template slot-scope="scope">
            <el-link @click="updateInfo(scope.row)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="二级域名">
          <template slot-scope="scope">
            <el-link @click="GogoSchool(scope.row.domain)" type="info">
              {{ scope.row.domain }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" label="地区">
          <template slot-scope="scope">
            <span>{{ scope.row.province }}-</span>
            <span>{{ scope.row.city }}-</span>
            <span>{{ scope.row.area }}</span>
          </template>
        </el-table-column>

        <el-table-column width="200" align="left" label="超管信息">
          <template slot-scope="scope">
            <span v-for="item of scope.row.principalList" :key="item.id">
              <span>{{ item.realname }}</span>
              <span>{{ '(' + item.name + ')' }}</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="已用空间">
          <template slot-scope="scope">
            <span v-if="
                scope.row.use_storage >= 1024 && scope.row.use_storage < 1048576
              ">
              {{ parseFloat(scope.row.use_storage / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.use_storage < 1024">{{ scope.row.use_storage }} KB</span>
            <span v-else>
              {{ parseFloat(scope.row.use_storage / 1024 / 1024).toFixed(2) }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="总空间">
          <template slot-scope="scope">
            <span v-if="
                scope.row.total_storage >= 1024 &&
                  scope.row.total_storage < 1048576
              ">
              {{ parseFloat(scope.row.total_storage / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.total_storage < 1024">{{ scope.row.total_storage }} KB</span>
            <span v-else>
              {{ parseFloat(scope.row.total_storage / 1024 / 1024).toFixed(2) }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column width="150" align="left" label="剩余流量">
          <template slot-scope="scope">
            <span v-if="
                scope.row.remain_traffic >= 1024 &&
                  scope.row.remain_traffic < 1048576
              ">
              {{ parseFloat(scope.row.remain_traffic / 1024).toFixed(2) }}
              MB
            </span>
            <span v-else-if="scope.row.remain_traffic < 1024">{{ scope.row.remain_traffic }} KB</span>
            <span v-else>
              {{
                parseFloat(scope.row.remain_traffic / 1024 / 1024).toFixed(2)
              }}
              GB
            </span>
          </template>
        </el-table-column>

        <el-table-column width="180" align="left" prop="stu_remain_time" label="剩余学员时长(天)"></el-table-column>

        <el-table-column width="150" align="left" label="客户标签">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="item in scope.row.schoolTagArr" :key="item.id" :color="item.tagInfo.color">
              <span style="color: white">{{ item.tagInfo.name }}</span>
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column width="100" align="center" label="题库权限">
          <template slot-scope="scope">
            <el-tag size="mini" type="success" effect="dark" v-if="scope.row.question_bank_permission"></el-tag>
            <el-tag size="mini" v-else type="info" effect="dark"></el-tag>
          </template>
        </el-table-column>
        <el-table-column width="80" label="科目权限" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.schoolSubjectAuthArr" :key="index">
              {{ item.subjectInfo.name }} - {{ item.off_time }}
            </span>
          </template>
        </el-table-column>
        <el-table-column width="100" prop="name" label="合作状态">
          <template slot-scope="scope">
            <span v-if="
                new Date().getTime() - new Date(scope.row.off_time).getTime() <
                  0
              ">合作中</span>
            <span v-else>已流失</span>
            <!-- <span style="color:green;cursor: pointer;" v-if="scope.row.implement_type === 1"
             >合作中</span>
            <span style="color:red; cursor: pointer;" v-if="scope.row.implement_type === 2"
              >已流失</span>
            <span style="color:red;cursor: pointer;" v-if="scope.row.implement_type === 3"
             >废弃校区</span>
            <span style="color:#E6A23C;cursor: pointer;" v-if="scope.row.implement_type === 4"
            >内部测试</span> -->
          </template>
        </el-table-column>

        <el-table-column width="500" align="center" label="公众平台授权">
          <template slot-scope="scope">
            <span v-if="scope.row.is_authorize">
              <span class="wechat_name" v-if="
                  scope.row.authorizer_service_type_info == 0 ||
                    scope.row.authorizer_service_type_info == 1
                ">{{ scope.row.name }}-订阅号</span>
              <span class="wechat_name" v-else-if="scope.row.authorizer_service_type_info == 2">{{ scope.row.authorizer_nick_name }}-服务号</span>

              <span class="wechat_label" style="margin-left: 10px">
                <span v-if="scope.row.authorizer_verify_type_info == -1">未认证</span>
                <span style="color: green" v-else>已认证</span>
              </span>
              <!-- <br />
              <span style="margin-left: 10px; color: #409eff; cursor: pointer" @click="getIndustry(scope.row)">查看行业</span>
              <span style="margin-left: 10px; color: #409eff; cursor: pointer"
                @click="getTemplateList(scope.row)">查看模板</span>
              <span style="margin-left: 10px; color: #409eff; cursor: pointer"
                @click="addTemplates(scope.row)">同步模板</span> -->
            </span>
          </template>
        </el-table-column>

        <el-table-column width="180" align="left" prop="remarks" label="备注"></el-table-column>

        <el-table-column width="150" align="left" prop="off_time" label="到期时间"></el-table-column>

        <el-table-column align="center" label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                权限管理
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="AddSubject(scope.row)">科目授权</el-dropdown-item>

                <el-dropdown-item @click.native="AddCourse(scope.row)">课程授权</el-dropdown-item>

                <el-dropdown-item @click.native="AddData(scope.row)">校区资源</el-dropdown-item>

                <el-dropdown-item @click.native="AddAccount(scope.row)">校长管理</el-dropdown-item>
                <el-dropdown-item @click.native="AddTeach(scope.row)">教师管理</el-dropdown-item>
                <el-dropdown-item @click.native="AddSchoTeach(scope.row)">分校管理</el-dropdown-item>

                <el-dropdown-item @click.native="AddSchoolTime(scope.row)">添加时长</el-dropdown-item>

                <!-- <el-dropdown-item @click.native="LookOrder(scope.row)">查询订单1</el-dropdown-item> -->

                <el-dropdown-item @click.native="AddFiles(scope.row)">下载中心</el-dropdown-item>

                <el-dropdown-item @click.native="EtidTime(scope.row)">合作日期</el-dropdown-item>
                <el-dropdown-item @click.native="update(scope.row)">设置套餐</el-dropdown-item>
                <el-dropdown-item @click.native="contract(scope.row)">校区合同</el-dropdown-item>
                <el-dropdown-item @click.native="changeRecord(scope.row)">变更记录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-sizes="[20, 30, 40, 50, 100]" :current-page.sync="page_no" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog :title="schoolId ? '修改学校信息' : '新增合作学校'" :visible.sync="dialogVisible" width="60%">
      <el-form class="form-style" ref="form" :model="form" :rules="rules" label-width="100px" label-position="left" size="small">
        <el-form-item label="学校名称" required prop="educational_institution_name">
          <el-input placeholder="请输入学校名称" v-model="form.educational_institution_name" style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="二级域名" required prop="domain">
          <el-input placeholder="请输入二级域名" v-model="form.domain" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="截止日期" required prop="off_time">
          <el-date-picker v-model="form.off_time" type="date" placeholder="请选择系统截止日期" value-format="yyyy-MM-dd" placement="bottom-start">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="最大分校数" required prop="max_campus_num">
          <el-input-number v-model="form.max_campus_num" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="最大教师数" required prop="max_teacher_num">
          <el-input-number v-model="form.max_teacher_num" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item label="设置套餐" v-if="this.schoolId ? false : true">
          <el-select v-model="form.meal_id">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--
        <el-form-item label="最大学生数" required prop="max_student_num">
          <el-input-number
            v-model="form.max_student_num"
            :precision="0"
          ></el-input-number>
        </el-form-item>
        -->
        <el-form-item label="地区信息">
          <myDistrict :province.sync="form.province" :city.sync="form.city" :area.sync="form.area"></myDistrict>
        </el-form-item>

        <el-form-item label="客户标签">
          <el-select v-model="form.tagIds" multiple placeholder="请选择">
            <el-option v-for="item in schoolTagList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赛考中心">
          <el-switch v-model="form.question_bank_permission"></el-switch>
        </el-form-item>
        <el-form-item label="信奥专区">
          <el-switch v-model="form.oj_permission"></el-switch>
        </el-form-item>
        <el-form-item label="开启通知">
          <el-switch v-model="form.admin_notice_auth"></el-switch>
        </el-form-item>
        <el-form-item label="赛考中心版本">
          <el-radio-group v-model="form.question_bank_show_type">
            <el-radio :label="2">新版本</el-radio>
            <el-radio :label="1">老版本</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="学校星级">
          <el-select v-model="form.star_num" placeholder="请选择" @change="$forceUpdate()">
            <el-option v-for="(item, index) in schoolStarList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="校区状态">
          <el-select v-model="form.implement_type" placeholder="请选择" @change="$forceUpdate()">
            <el-option v-for="(item, index) in schoolimplement_type" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注">
          <el-input placeholder="请输入学校备注" v-model="form.remarks" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="Api-Key">
          <el-input placeholder="请输入Api-Key" v-model="form.ApiKey" style="width: 400px" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增课程权限" :visible.sync="dialogVisible1" width="80%">
      <el-form ref="form1" :model="form1" label-position="left" size="mini" :inline="true">
        <el-form-item label="所属科目">
          <el-select v-model="form1.subject_id" placeholder="请选择科目" @change="getCurriculumList('change')" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) of subjectList" :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程类别">
          <el-select v-model="form1.curriculum_type" @change="getCurriculumList('change')" clearable>
            <el-option label="体验课" :value="1"></el-option>
            <el-option label="常规课" :value="2"></el-option>
            <el-option label="短期课" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-table size="mini" :data="curriculum_list" :header-cell-style="{ background: '#f5f7fa' }" tooltip-effect="dark" highlight-current-row style="width: 100%" @row-click="handleSelectionChange1" height="400px">
        <el-table-column align="center" width="50" label="序号">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + 20 * (page_no - 1) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="授课类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.teaching_type == '1'">面授课</span>
            <span v-else-if="scope.row.teaching_type == '2'">直播课</span>
            <span v-else-if="scope.row.teaching_type == '3'">录播课</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="center" label="课程类别">
          <template slot-scope="scope">
            <span v-if="scope.row.curriculum_type == '1'">体验课</span>
            <span v-else-if="scope.row.curriculum_type == '2'">常规课</span>
            <span v-else-if="scope.row.curriculum_type == '3'">短期课</span>
          </template>
        </el-table-column>

        <el-table-column width="100" prop="id" label="课程封面" align="center">
          <template slot-scope="scope">
            <el-image style="width: 32.5px; height: 15px" :src="scope.row.img_url" fit="cover"></el-image>
          </template>
        </el-table-column>

        <el-table-column prop="subjectName" label="科目名称" width="100"></el-table-column>

        <el-table-column prop="title" label="课程名称"></el-table-column>

        <el-table-column prop="curriculum_desc" label="课程介绍" :show-overflow-tooltip="true"></el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit2">确认授权</el-button>
        <el-button size="small" @click="quitDialog2('form1')">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="更新套餐" :visible.sync="dialogVisible2" width="50%">
      <el-form ref="form2" :model="form2" size="mini" label-position="left">
        <el-form-item label="是否有效">
          <el-select v-model="form2.meal_id" @change="$forceUpdate()">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible2 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submit3">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEducationalInstitutionList,
  addEducationalInstitution,
  updateEducationalInstitution,
  // getPrincipalUserList,
  adminGetSchoolTagList,
  // getIndustry,
  // getTemplateList,
  // addTemplates,
  getSubjectList,
  bulkAddCurriculumAuthForSchools,
  // adminMealGet,
  // adminUpdateEducationalInstitutionMeal,
} from '@/api/admin'
import {
  api_mealQueryValidList,
  api_eduMealViewDetail,
  api_eduMealEdit,
} from '@/api/javaApi'
import { getCurriculumList } from '@/api/educational'

import myDistrict from '../../../../components/myDistrict/myDistrict.vue'

export default {
  name: 'cooperative-school',
  data() {
    return {
      options: [],
      curriculumItem: {
        currId: '',
        subjectId: '',
      },
      curriculum_id: [],
      curriculum_list: [],
      multipleSelection: [],
      userList: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      form2: {},
      subjectList: [],
      ruleForm: {
        date: [],
        tagIds: [],
        subjectIds: [],
        username: '',
        educational_institution_name: '',
        is_contain_timeout_subject: '',
      },
      form1: {
        curriculum_id: '',
        educational_institution_id: '',
        max_teacher_num: 5,
        course_authority: '',
        subject_id: '',
        off_time: '',
        current_curriculum_num: 0,
        teaching_type: '1',
        curriculum_type: '',
      },
      form: {
        meal_id: '',
        ApiKey: '',
        educational_institution_name: '',
        domain: '',
        max_campus_num: 1,
        max_teacher_num: 1,
        max_student_num: 1,
        off_time: '',
        remarks: '',
        tagIds: [],
        province: '',
        city: '',
        area: '',
        question_bank_permission: false,
        oj_permission: false,
        admin_notice_auth: false,
        question_bank_show_type: 2,
      },
      schoolId: '',
      schoolTagList: [], //标签页面
      tableData: [],
      total: 0,
      page_no: 1,
      page_size: 20,
      schoolStarList: [
        {
          id: 1,
          name: '一星',
        },
        {
          id: 2,
          name: '二星',
        },
        {
          id: 3,
          name: '三星',
        },
        {
          id: 4,
          name: '四星',
        },
        {
          id: 5,
          name: '五星',
        },
        {
          id: 6,
          name: '使用不规范',
        },
      ],
      schoolimplement_type: [
        {
          id: 1,
          name: '合作中',
        },
        {
          id: 2,
          name: '已流失',
        },
        {
          id: 3,
          name: '废弃校区',
        },
        {
          id: 4,
          name: '内部测试',
        },
      ],
      rules: {
        educational_institution_name: [
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'blur',
          },
        ],
        domain: [
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入二级域名',
            trigger: 'blur',
          },
        ],
        remarks: [
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入学校备注',
            trigger: 'blur',
          },
        ],
        off_time: [
          { required: true, message: '请选择系统截止日期', trigger: 'change' },
          { required: true, message: '请选择系统截止日期', trigger: 'blur' },
        ],
        offset: 0,
      },
    }
  },

  components: { myDistrict },

  mounted() {
    this.getUserSubjectList()

    this.getEducationalInstitutionList()
    // this.getPrincipalUserList();
    this.adminGetSchoolTagList()
    this.adminMealGet()
  },
  methods: {
    //批量添加
    submit2() {
      bulkAddCurriculumAuthForSchools({
        eduIdList: this.multipleSelection,
        list: [this.curriculumItem],
      }).then((res) => {
        console.log(res)
        this.$message.success('添加成功')
        this.dialogVisible1 = false
      })
    },
    getCurriculumList(status) {
      if (status === 'change') {
        this.form1.curriculum_id = ''
      }
      getCurriculumList(
        {
          subject_id: this.form1.subject_id,
          teaching_type: this.form1.teaching_type,
          curriculum_type: this.form1.curriculum_type,
          page_size: 200,
        },
        true
      ).then((res) => {
        console.log('查询课程体系')
        console.log(res)

        this.curriculum_list = res.curriculum_list
        //this.form.current_curriculum_num
      })
    },

    allAdd() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择校区')
      } else {
        this.dialogVisible1 = true
        this.getCurriculumList()
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = []
      val.map((item) => {
        this.multipleSelection.push(item.id)
        console.log(this.multipleSelection)
      })
      console.log(this.multipleSelection)
    },
    handleSelectionChange1(val) {
      console.log(val)
      this.curriculumItem = {
        currId: val.id,
        subjectId: val.subject_id,
      }
    },
    getUserSubjectList() {
      getSubjectList({
        subject_state: '',
      }).then((res) => {
        this.subjectList = res.subject_list
      })
    },
    //获得行业信息
    // getIndustry(row) {
    //   console.log(row);
    //   getIndustry({
    //     schoolId: row.id
    //   }).then(res => {
    //     console.log("获得行业信息");
    //     console.log(res);
    //     if (res.industry_data.primary_industry) {
    //       this.$notify({
    //         title: "行业信息",
    //         message:
    //           res.industry_data.primary_industry.first_class +
    //           "-" +
    //           res.industry_data.primary_industry.second_class
    //       });
    //     }

    //     if (res.industry_data.secondary_industry) {
    //       this.$notify({
    //         title: "行业信息",
    //         message:
    //           res.industry_data.secondary_industry.first_class +
    //           "-" +
    //           res.industry_data.secondary_industry.second_class,
    //         offset: 100
    //       });
    //     }
    //   });
    // },

    //获得模板列表
    // getTemplateList(row) {
    //   getTemplateList({
    //     schoolId: row.id
    //   }).then(res => {
    //     console.log("获得模板列表");
    //     console.log(res);

    //     this.offset = 0;
    //     for (let k = 0; k < res.templateList.length; k++) {
    //       this.$notify({
    //         title: res.templateList[k].title,
    //         message: res.templateList[k].template_id,
    //         offset: this.offset
    //       });

    //       this.offset = this.offset + 100;
    //     }
    //   });
    // },

    //同步模板消息
    // addTemplates(row) {
    //   if (row.wxTemplateArr.length > 0) {
    //     this.$confirm("已同步过模板消息,确定重新同步吗?", "提示", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning"
    //     }).then(() => {
    //       addTemplates({
    //         schoolId: row.id
    //       }).then(res => {
    //         console.log("同步模板列表");
    //         console.log(res);

    //         if (res.is_create) {
    //           this.$message.success("同步成功");
    //         }
    //       });
    //     });
    //   } else {
    //     addTemplates({
    //       schoolId: row.id
    //     }).then(res => {
    //       console.log("同步模板列表");
    //       console.log(res);

    //       if (res.is_create) {
    //         this.$message.success("同步成功");
    //       }
    //     });
    //   }
    // },

    //查询校区标签
    adminGetSchoolTagList() {
      adminGetSchoolTagList().then((res) => {
        console.log('查询校区标签')
        console.log(res)
        this.schoolTagList = res.schoolTagList
      })
    },

    // // 获取校长账号列表
    // getPrincipalUserList() {
    //   getPrincipalUserList({
    //     page_size: 200
    //   }).then(res => {
    //     this.userList = res.principal_user_list;
    //   });
    // },
    // 修改信息
    updateInfo(row) {
      console.log('更新学校信息')
      console.log(row)
      this.schoolId = row.id
      this.form.educational_institution_name = row.name
      this.form.domain = row.domain
      this.form.max_teacher_num = row.max_teacher_num
      this.form.max_student_num = row.max_student_num
      this.form.off_time = row.off_time
      this.form.remarks = row.remarks
      this.form.max_campus_num = row.max_campus_num
      this.form.ApiKey = row.chat_gpt_key
      this.form.question_bank_permission = row.question_bank_permission
      this.form.oj_permission = row.oj_permission
      this.form.admin_notice_auth = row.admin_notice_auth
      this.form.question_bank_show_type = row.question_bank_show_type
      this.form.star_num = row.star_num
      this.form.implement_type = row.implement_type
      this.form.province = row.province
      this.form.city = row.city
      this.form.area = row.area

      this.form.tagIds = []
      for (let k = 0; k < row.schoolTagArr.length; k++) {
        this.form.tagIds.push(row.schoolTagArr[k].tagInfo.id)
      }

      this.dialogVisible = true
    },
    changeRecord(row) {
      console.log('变更记录')
      this.$router.push({
        name: 'record',
        query: {
          id: row.id,
        },
      })
    },

    AddFiles(row) {
      console.log('下载中心')
      this.$router.push({
        name: 'download-management',
        query: {
          id: row.id,
        },
      })
    },
    EtidTime(row) {
      console.log('合作日期')
      sessionStorage.setItem('time', row.stop_date)
      this.$router.push({
        name: 'cooperation-time',
        query: {
          id: row.id,
          time: row.stop_date,
        },
      })
    },

    AddSubject(row) {
      console.log('科目授权')
      this.$router.push({
        name: 'school-subject-permissions',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddCourse(row) {
      console.log('课程授权')
      this.$router.push({
        name: 'school-system-permissions',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddAccount(row) {
      console.log('添加校长')
      this.$router.push({
        name: 'principal-management',
        query: {
          id: row.id,
          domain: row.domain,
          name: row.name,
        },
      })
    },
    AddSchoTeach(row) {
      console.log('分校管理')
      this.$router.push({
        name: 'BranchManagement',
        query: {
          id: row.id,
          domain: row.domain,
          name: row.name,
        },
      })
    },
    AddTeach(row) {
      console.log('教师管理')
      this.$router.push({
        name: 'teacher-management',
        query: {
          id: row.id,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    AddSchoolTime(row) {
      this.$router.push({
        name: 'create-order',
        query: {
          id: row.id,
          name: row.name,
        },
      })
    },

    AddData(row) {
      console.log('添加流量')
      this.$router.push({
        name: 'data-management',
        query: {
          id: row.id,
          off_time: row.off_time,
          domain: row.domain,
          name: row.name,
        },
      })
    },

    // LookOrder(row) {
    //   console.log("查询校区订单");
    //   this.$router.push({
    //     name: "look-order",
    //     query: {
    //       id: row.id,
    //       name: row.name
    //     }
    //   });
    // },
    contract(row) {
      console.log('校区合同')
      this.$router.push({
        name: 'contract',
        query: {
          id: row.id,
        },
      })
    },

    quitDialog() {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },
    quitDialog2() {
      this.dialogVisible1 = false
    },
    // 添加合作学校
    addSchool() {
      this.schoolId = ''

      this.form = {
        educational_institution_name: '',
        domain: '',
        max_campus_num: 1,
        max_teacher_num: 1,
        max_student_num: 1,
        off_time: '',
        remarks: '',
        tagIds: [],
        province: '',
        city: '',
        area: '',
        question_bank_permission: false,
        oj_permission: false,
        admin_notice_auth: false,
        question_bank_show_type: 2,
        star_num: 0,
        implement_type: 1,
        meal_id: this.options[0].id,
      }
      // this.form.meal_id = this.options[0].id
      this.dialogVisible = true
    },
    search() {
      this.page_no = 1
      this.getEducationalInstitutionList()
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.schoolId) {
            updateEducationalInstitution({
              educational_institution_id: this.schoolId,
              educational_institution_name: this.form
                .educational_institution_name,
              domain: this.form.domain,
              max_campus_num: this.form.max_campus_num,
              max_teacher_num: this.form.max_teacher_num,
              max_student_num: this.form.max_student_num,
              off_time: this.form.off_time,
              remarks: this.form.remarks,
              chat_gpt_key: this.form.ApiKey,
              tagIds: JSON.stringify(this.form.tagIds),
              province: this.form.province,
              question_bank_permission: this.form.question_bank_permission,
              oj_permission: this.form.oj_permission,
              admin_notice_auth: this.form.admin_notice_auth,
              question_bank_show_type: this.form.question_bank_show_type,
              star_num: this.form.star_num,
              implement_type: this.form.implement_type,

              city: this.form.city,
              area: this.form.area,
            }).then((res) => {
              console.log('修改学校信息')
              console.log(res)
              if (res.is_update) {
                this.$message.success('修改成功')
                this.quitDialog()
                this.getEducationalInstitutionList()
              }
            })
          } else {
            console.log('新建校区参数')
            console.log(this.form)
            addEducationalInstitution({
              name: this.form.educational_institution_name,
              domain: this.form.domain,
              authMealId: this.form.meal_id,
              maxCampusNum: this.form.max_campus_num,
              maxTeacherNum: this.form.max_teacher_num,
              // max_student_num: this.form.max_student_num,
              offTime: this.form.off_time + ' 23:59:59',
              remarks: this.form.remarks,
              // chat_gpt_key: this.form.ApiKey,
              tagIds: this.form.tagIds,
              province: this.form.province,
              questionBankPermission: this.form.question_bank_permission,
              ojPermission: this.form.oj_permission,
              adminNoticeAuth: this.form.admin_notice_auth,
              questionBankShowType: this.form.question_bank_show_type,

              starNum: this.form.star_num,
              implementType: this.form.implement_type,

              city: this.form.city,
              area: this.form.area,
            }).then((res) => {
              console.log('新增合作校区')
              console.log(res)
              this.$message.success('添加合作学校成功')
              this.quitDialog()
              this.getEducationalInstitutionList()
            })
          }
        }
      })
    },
    // 获取合作学校列表
    getEducationalInstitutionList() {
      getEducationalInstitutionList({
        is_try: 0,
        domain: this.ruleForm.domain,
        offtime_start_search: this.ruleForm.date ? this.ruleForm.date[0] : '',
        offtime_end_search: this.ruleForm.date ? this.ruleForm.date[1] : '',
        is_contain_timeout_subject: this.ruleForm.is_contain_timeout_subject,

        tagIds: JSON.stringify(this.ruleForm.tagIds),
        subjectIds: JSON.stringify(this.ruleForm.subjectIds),
        educational_institution_name: this.ruleForm
          .educational_institution_name,
        username: this.ruleForm.username,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('校区列表')
        console.log(res)
        this.tableData = res.educational_institution_list
        this.total = res.total
        for (let k = 0; k < this.tableData.length; k++) {
          this.tableData[k].classlist = []
          for (
            let j = 0;
            j < this.tableData[k].schoolSubjectAuthArr.length;
            j++
          ) {
            this.tableData[k].classlist.push(
              this.tableData[k].schoolSubjectAuthArr[j].subjectInfo.name
            )
          }

          this.tableData[k].subject = this.tableData[k].classlist.join(' , ')
        }
      })
    },

    GogoSchool(domain) {
      console.log('二级域名跳转')
      console.log(domain)
      window.open('https://' + domain + '.steam.fun', '_blank')
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.getEducationalInstitutionList()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.getEducationalInstitutionList()
    },
    //更新套餐
    eduMealViewDetail(id) {
      this.form2.institution_id = id
      api_eduMealViewDetail({
        eduId: id,
      }).then((res) => {
        console.log(res)
        this.form2.meal_id = res.id
        this.dialogVisible2 = true
      })
    },
    adminMealGet() {
      api_mealQueryValidList({
        // page_no: 1,
        // page_size: 20,
      }).then((res) => {
        console.log('查询角色列表')
        console.log(res, 214545)
        this.options = res
      })
    },
    update(row) {
      console.log(row)
      this.eduMealViewDetail(row.id)
    },
    submit3() {
      api_eduMealEdit({
        eduId: this.form2.institution_id,
        mealId: this.form2.meal_id,
      }).then(() => {
        this.dialogVisible2 = false
        this.$message.success('设置套餐成功')
        this.getEducationalInstitutionList()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.cooperative-school {
  padding: 20px;
  margin: 10px;
  background-color: #fff;
  border-radius: 5px;

  .form-style {
    margin-left: 15px;
  }

  .btn {
    margin-top: 15px;
  }
}

.cooperative-school /deep/ .el-form-item {
  margin-bottom: 20px;
}

.table-style {
  margin-top: 48px;
}
</style>
